<template>
    
    <div class="positionRelative">
        <BeerForm v-model="beers" @back="back" @submitBeerForm="submit"></BeerForm>
    </div>
</template>

<script>
    import BeerForm from "../components/BeerForm";
    import _ from 'lodash';

    export default {
        name: "BeerRegistration",
        components: {BeerForm},

        store : ['registration', 'currentView'],

        created: function () {
            this.beers = this.registration.beers;
        },

        methods : {

            back () {
                this.currentView = 'contact';
            },

            submit() {
                this.registration.beers = this.beers;
                if(window.sessionStorage) {
                    let temp = _.cloneDeep(this.registration);
                    _.unset(temp, 'password');
                    window.sessionStorage.setItem('registration', JSON.stringify(temp));
                }
                this.currentView = 'confirm';
            }
        },

        data: function () {
            return {
                isLoading: false,
                beers: []
            };
        }
    }
</script>

<style scoped>

</style>